/*eslint-disable @typescript-eslint/strict-boolean-expressions */
import { createAppStore } from '@mobileStore/createAppStore';

import { DashboardStoreType } from './types';

const INITIAL_DASHBOARD_STORE: DashboardStoreType = {
  isSearchGlobalOpen: false,
  globalSearchHasError: false,
  announcementsData: [],
  alertsData: [],
  approvalsData: [],
  disputedLoadsData: [],
  efsChecksData: [],
  claimsData: [],
  billingHoldsData: [],
  needsPaperworkData: [],
  showLoaderFetch: false,
  badgeCounts: {
    announcementsCount: 0,
    alertsCount: 0,
    approvalsCount: 0,
    efsRequestsCount: 0,
    claimsCount: 0,
    billingHoldsCount: 0,
    needPaperworkCount: 0,
  },
};
const [dashboardStore, setDashboardStore] = createAppStore<DashboardStoreType>(
  INITIAL_DASHBOARD_STORE,
  'dashboardStore',
);

export { dashboardStore, setDashboardStore };
